// A top-level GET, not a form POST: the broker answers with a 302 to Cognito or the IdP, which form-action would block.
export const buildFederatedForwardUrl = (brokerBaseUrl: string, request: string, poolId: string, identityProvider: string) => {
    const params = new URLSearchParams({
                                           request,
                                           pool: poolId,
                                           identity_provider: identityProvider,
                                       });
    return `${brokerBaseUrl}/handoff/federated?${params.toString()}`;
};

export const forwardToBrokerFederated = (brokerBaseUrl: string, request: string, poolId: string, identityProvider: string) => {
    window.location.assign(buildFederatedForwardUrl(brokerBaseUrl, request, poolId, identityProvider));
};
